import {Snackbar, Button, FormHelperText} from '@material-ui/core'
import {Alert} from '@material-ui/lab'
import {CameraAltRounded} from '@material-ui/icons'
import React, {useState, useRef, Fragment, useCallback} from 'react'
import {CustomWebcam, Frame, ImagePreview, WebcamWrapper} from './styles'

const WebcamCapture = ({field, form, helperText, frame, facingMode, ...props}) => {
  const {setFieldValue} = form
  const [open, setOpen] = useState(true)
  const [imageSrc, setImageSrc] = useState(null)
  const onChangeLegacyImage = async ({target}) => {
    let [file] = target.files
    let reader = new FileReader()
    reader.onloadend = () => {
      setImageSrc(reader.result)
      setFieldValue(field.name, reader.result)
    }
    reader.readAsDataURL(file)
  }
  const capture = useCallback(
    () => {
      let screenshot = webcamRef.current.getScreenshot()
      if (screenshot === null) {
        inputFileRef.current.click()
      } else {
        setImageSrc(screenshot)
        setFieldValue(field.name, screenshot)
      }
    },
    [setFieldValue, field]
  )
  const webcamRef = useRef(null)
  const inputFileRef = useRef(null)

  const videoConstraints = {
    width: 600,
    height: 800,
    facingMode
  }
  const error = form.errors[field.name]
  const touched = form.touched[field.name]
  const showError = touched && !!error
  return (
    <Fragment>
      {imageSrc ? (
        <Fragment>
          <ImagePreview src={imageSrc} alt={field.name} />
          <Button
            variant="outlined"
            startIcon={<CameraAltRounded />}
            fullWidth
            onClick={() => setImageSrc(null)}>
            Tirar outra foto
          </Button>
        </Fragment>
      ) : (
        <Fragment>
          <WebcamWrapper>
            {frame && (
              <Frame src={frame} alt="" />
            )}
            <CustomWebcam
              error={showError}
              ref={webcamRef}
              audio={false}
              height="100%"
              screenshotFormat="image/jpeg"
              width="100%"
              videoConstraints={videoConstraints}
              {...props}
            />
          </WebcamWrapper>
          <FormHelperText component="p" error={showError}>{showError ? error : helperText}</FormHelperText>
          <input
            type="file"
            hidden
            ref={inputFileRef}
            onChange={onChangeLegacyImage}
          />
          <Button
            variant="outlined"
            startIcon={<CameraAltRounded />}
            fullWidth
            onClick={capture}>
            Tirar foto
          </Button>
          <Snackbar open={showError && open} autoHideDuration={6000} onClose={() => setOpen(false)}>
            <Alert onClose={() => setOpen(false)} severity="info">
              Toque em tirar foto e depois em enviar
            </Alert>
          </Snackbar>
        </Fragment>
      )}
    </Fragment>
  )
}

export default WebcamCapture
